import { codigoBancoDeIban } from '@adelante/shared';

export interface ColorBanco {
  /** Seleccionado o relleno. */
  activo: string;
  /** Ficha o sugerencia. */
  suave: string;
  /** Contorno de la ficha. */
  borde: string;
}

const GRIS: ColorBanco = {
  activo: 'bg-zinc-600 text-white',
  suave: 'bg-zinc-100 text-zinc-700',
  borde: 'border-zinc-200',
};

/** Colores parecidos al logo de cada banco, por código de banco del IBAN. Los demás van en gris. */
const COLOR_POR_CODIGO: Record<string, ColorBanco> = {
  // BAC: rojo
  '0102': {
    activo: 'bg-red-600 text-white',
    suave: 'bg-red-50 text-red-700',
    borde: 'border-red-200',
  },
  // BN: verde (cercano al de Adelante)
  '0151': {
    activo: 'bg-lime-700 text-white',
    suave: 'bg-lime-50 text-lime-800',
    borde: 'border-lime-200',
  },
  // BCR: azul
  '0152': {
    activo: 'bg-blue-700 text-white',
    suave: 'bg-blue-50 text-blue-800',
    borde: 'border-blue-200',
  },
  // Mutual Cartago (Mucap): celeste
  '0804': {
    activo: 'bg-sky-500 text-white',
    suave: 'bg-sky-50 text-sky-700',
    borde: 'border-sky-200',
  },
  // Cathay: vino
  '0125': {
    activo: 'bg-[#7f2529] text-white',
    suave: 'bg-[#f7ecec] text-[#7f2529]',
    borde: 'border-[#e4c7c8]',
  },
  // Banco CMB (Citi): azul brillante
  '0127': {
    activo: 'bg-blue-500 text-white',
    suave: 'bg-blue-50 text-blue-600',
    borde: 'border-blue-200',
  },
  // Banco Popular: naranja
  '0161': {
    activo: 'bg-orange-500 text-white',
    suave: 'bg-orange-50 text-orange-700',
    borde: 'border-orange-200',
  },
  // Davibank y Davivienda: rojo carmesí
  '0123': {
    activo: 'bg-rose-600 text-white',
    suave: 'bg-rose-50 text-rose-700',
    borde: 'border-rose-200',
  },
  '0104': {
    activo: 'bg-rose-600 text-white',
    suave: 'bg-rose-50 text-rose-700',
    borde: 'border-rose-200',
  },
  // Promérica: verde medio
  '0116': {
    activo: 'bg-green-600 text-white',
    suave: 'bg-green-50 text-green-700',
    borde: 'border-green-200',
  },
  // Lafise: verde oscuro
  '0114': {
    activo: 'bg-emerald-900 text-white',
    suave: 'bg-emerald-50 text-emerald-900',
    borde: 'border-emerald-200',
  },
};

export const COLOR_BANCO = {
  BAC: COLOR_POR_CODIGO['0102'] ?? GRIS,
  BN: COLOR_POR_CODIGO['0151'] ?? GRIS,
  OTRO: GRIS,
};

/** Color del banco al que pertenece un IBAN (gris si no se reconoce). */
export function colorDeIban(iban: string | null | undefined): ColorBanco {
  const codigo = codigoBancoDeIban(iban);
  return (codigo && COLOR_POR_CODIGO[codigo]) || GRIS;
}
